import React, { useContext } from "react";
import { StakeContext } from "../context";
import { SecondaryTile } from "./secondary-tile";

const PriceTile: React.FunctionComponent<{}> = () => {
  const { currentContract } = useContext(StakeContext);

  return currentContract.fold(
    () => null,
    (contract) => (
      <SecondaryTile title="$SKRT Price">
        ${contract.tokenPrice.toString()}
      </SecondaryTile>
    )
  );
};

export default PriceTile;
